import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { StorageService } from '../services/general-utils';
import { CookieService } from 'ngx-cookie-service';

export interface ErrorInfo {
  status: number;
  title: string;
  detail: string;
}

@Injectable()
export class ErrorHandlerInterceptor implements HttpInterceptor {
  constructor(
    private translate: TranslateService,
    private router: Router,
    private storageService: StorageService,
    private cookieService: CookieService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        return event;
      }),
      catchError((err, caught) => {
        if ((err.url && err.url.includes('utenti/utente-loggato'))
            || err.status === 401 || err.status === 403) {
          // errore di re-login con token CAS scaduto --> non apro popup di errore ma atterro direttamente in login
          this.openErrorModalServer(this.translate.instant('accessoNonRiuscito'));
          this.storageService.clear();
          this.cookieService.delete('XSRF-TOKEN', '/');
          this.router.navigate(['/login']);
          return new Observable<never>();
        } else if (err.status === 0) {
          this.openErrorModalServer('Impossible to connect to remote server');
        } else {
          this.openErrorModal(err);
        }
        if (err instanceof HttpErrorResponse && err.error) {
          // check se c'è veramente un errore dentro "errors" (ad esempio nel validate rating torna successResult=false con errors vuoto
          const errorDetails: any = err.error;
          if (errorDetails) {
            const errorInfo: ErrorInfo = {
              status: errorDetails.status,
              title: errorDetails.title,
              detail: errorDetails.detail ? errorDetails.detail : null
            };
            this.openErrorModal(errorInfo);
          }
        }
        return throwError(err);
      })
    );
  }

  openErrorModal(errInfo: ErrorInfo): void {
    // controllo se l'error ha la struttura(errorTitle, exceptionMessage, cause e subErrors).
    // altrimento lo interpreto come stringa(come gli errori 500) e li mostro sullo swal.(occhio che viene fatto il JSON.stringfy al inizio)
    // const errInfo = errorText && errorText.indexOf('errorTitle') !== -1 ? JSON.parse(errorText) : errorText;

    // componiamo il contenuto dello swal di errore:
    let htmlContent = '';
    if (errInfo && errInfo.detail) {
      htmlContent +=
        '<button id="collapse-swal" class="swal2-confirm swal2-styled font-sm" ' +
        'style="display: inline-block; border-left-color: #29363d; border-right-color: #29363d;">' +
        this.translate.instant('errore') +
        '</button><br/><br/>' +
        '<div id="error-frame" style="display:none; font-size:medium; max-height: 10rem; overflow-y: auto; overflow-x: auto;">' +
        ' <div style="text-align: left">';
      if (errInfo.detail) {
        htmlContent += ' <p>' + errInfo.detail + '</p>';
      }
      htmlContent += '</div>';
    }

    Swal.fire({
      icon: 'error',
      title: '<div style="text-align: center; font-size: 1.5rem; line-height: normal; max-height: 6rem; overflow-y: auto;">' +
        (errInfo.status + ' - ' + errInfo.title) +
        '</div>',
      html: htmlContent,
      confirmButtonText: this.translate.instant('close'),
      willOpen: () => {
        const content = Swal.getContent();
        const $ = content.querySelector.bind(content);
        // ci devono per forza essere uno tra exception message e cause per mostrare il tasto "read more"
        if (errInfo && errInfo.detail) {
          const collapse = $('#collapse-swal');
          // @ts-ignore
          collapse.addEventListener('click', () => {
            // @ts-ignore
            const btnReadMore: HTMLButtonElement = $('#error-frame');
            if (btnReadMore.style.display === 'none') {
              btnReadMore.style.display = 'block';
            } else {
              btnReadMore.style.display = 'none';
            }
          });
        }
      }
    });
  }

  openErrorModalServer(errMsg: any): void {
    Swal.fire({
      icon: 'error',
      title: '<div style="text-align: left; font-size: 1.5rem;">' + errMsg + '</div>',
      confirmButtonText: this.translate.instant('close')
    });
  }
}